module.exports = __webpack_public_path__ + "img/title-1.6f0f8acb.png";